<template>
  <div>
    <b-dropdown variant="link" toggle-class="text-decoration-none" no-caret>
      <template v-slot:button-content>
        <font-awesome-icon
          class="mr-3"
          :icon="['fas', 'bars']"
          style="color: black;"
        />
      </template>
      <b-dropdown-item
        v-for="(level, index) in levels"
        :key="level.level"
        :to="'/foundation/' + level.level"
      >
        Exercise {{ index + 1 }}: {{ level.title }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import LevelRepository from "@/repositories/level-repository";

export default {
  name: "level-dropdown",

  data() {
    return {
      levels: []
    };
  },

  created() {
    this.getLevels();
  },

  methods: {
    getLevels() {
      this.levels = LevelRepository.getLevels();
    }
  }
};
</script>

<style></style>
